import React, {PureComponent} from "react";
import {motion} from "framer-motion";
import NPOCard from "../../components/NPOCard";
import PostCard from "../../components/PostCard";
import {NPO_DUMMY_SLIDES} from "../../utils/dummy";
import {wait} from "@testing-library/user-event/dist/utils";

const STEP_ORDER = {
    first: 0,
    second: 1,
    third: 2,
}

class Section5 extends PureComponent {
    state = {
        step: 'first',
        firstTranslation: 20,
        secondTranslation: 20,
        thirdTranslation: 20,
        autoPlay: true,
    }

    componentDidMount() {
        this.unfreezeCarousel()
    }

    unfreezeCarousel = () => {
        this.interval = setInterval(() => {
            this.next()
        }, 6000);
    }

    freezeCarousel = () => {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.autoPlay && !this.state.autoPlay) {
            this.freezeCarousel()
        }
        if (!prevState.autoPlay && this.state.autoPlay) {
            this.unfreezeCarousel()
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    navigateToStep = step => {
        const currentStep = this.state.step
        const movingForwards = STEP_ORDER[step] > STEP_ORDER[currentStep]
        this.setState(
            {opacity: 0, [`${currentStep}Translation`]: movingForwards ? -20 : 20},
            () => {
                wait(600)
                    .then(() => {
                        this.setState(
                            {step},
                            () => wait(300)
                                .then(() => this.setState({opacity: 1, [`${step}Translation`]: 0}))
                        )
                    })
            }
        )
    }

    next = () => {
        if (this.state.step === 'first') {
            this.navigateToStep('second')
        }
        if (this.state.step === 'second') {
            this.navigateToStep('third')
        }
        if (this.state.step === 'third') {
            this.navigateToStep('first')
        }
    }

    back = () => {
        if (this.state.step === 'second') {
            this.navigateToStep('first')
        }
        if (this.state.step === 'third') {
            this.navigateToStep('second')
        }
    }

    switchGraphic = () => {
        switch (this.state.step) {
            case 'first':
                return (
                    <div
                        style={{
                            transition: 'opacity 600ms ease, transform 300ms ease',
                            opacity: this.state.opacity,
                            transform: `translateY(${Math.abs(this.state.firstTranslation) / 2}px)`
                        }}
                    >
                        <div style={{marginRight: this.props.mobile && '4%'}}>
                            <NPOCard npo={NPO_DUMMY_SLIDES[0].npo} mobile={this.props.mobile}/>
                        </div>
                        <div style={{
                            marginTop: this.props.mobile ? -12 : -16,
                            marginLeft: this.props.mobile ? '4%' : '12%',
                            marginRight: this.props.mobile ? '0%' : '-4%'
                        }}>
                            <PostCard npo post={NPO_DUMMY_SLIDES[0].posts[0]} mobile={this.props.mobile}/>
                        </div>
                        <div style={{
                            marginTop: this.props.mobile ? -12 : -16,
                            marginRight: this.props.mobile ? '8%' : '12%'
                        }}>
                            <PostCard post={NPO_DUMMY_SLIDES[0].posts[1]} mobile={this.props.mobile}/>
                        </div>
                    </div>
                )
            case 'second':
                return (
                    <div
                        style={{
                            transition: 'opacity 600ms ease, transform 300ms ease',
                            opacity: this.state.opacity,
                            transform: `translateY(${Math.abs(this.state.secondTranslation) / 2}px)`
                        }}
                    >
                        <div style={{marginRight: this.props.mobile && '4%'}}>
                            <NPOCard npo={NPO_DUMMY_SLIDES[1].npo} mobile={this.props.mobile}/>
                        </div>
                        <div style={{
                            marginTop: this.props.mobile ? -12 : -8,
                            marginLeft: this.props.mobile ? '4%' : '20%',
                            marginRight: this.props.mobile ? '0%' : '-4%'
                        }}>
                            <PostCard npo post={NPO_DUMMY_SLIDES[1].posts[0]} mobile={this.props.mobile}/>
                        </div>
                    </div>
                )
            case 'third':
                return (
                    <div
                        style={{
                            transition: 'opacity 600ms ease, transform 300ms ease',
                            opacity: this.state.opacity,
                            transform: `translateY(${Math.abs(this.state.thirdTranslation) / 2}px)`
                        }}
                    >
                        <div style={{marginLeft: this.props.mobile ? '4%' : '15%'}}>
                            <NPOCard npo={NPO_DUMMY_SLIDES[2].npo} mobile={this.props.mobile}/>
                        </div>
                        <div style={{
                            marginTop: this.props.mobile ? -12 : -16,
                            marginLeft: this.props.mobile ? '-2%' : '-2%'
                        }}>
                            <PostCard post={NPO_DUMMY_SLIDES[2].posts[1]} mobile={this.props.mobile}/>
                        </div>
                    </div>
                )
            default:
                return null
        }
    }
    render() {
        return (
            <section className={this.props.mobile ? 'col-ac relative' : 'row-ac-jb relative'}
                     style={{
                         height: !this.props.mobile && '90vh',
                         backgroundColor: "rgb(245,248,255)",
                         padding: this.props.mobile ? '80px 24px' : '60px 10vw'
                     }}>
                <motion.div style={{flex: 1, maxWidth: !this.props.mobile && '30vw'}}
                            initial={{opacity: 0, transform: 'scale(1) translateY(12px)'}}
                            whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                            transition={{default: {ease: "linear"}, delay: .2}}
                            className={this.props.mobile ? 'mb-40 col-plain' : 'col-plain'}>
                    <div className='body3-bold black-50 mb-8' style={{textTransform: 'uppercase'}}>
                        INVITE
                    </div>
                    <h1 className='heading2 black-100 mb-24 mt-0'>
                        Build your own Good Network
                    </h1>
                    <p className='mt-0 body1 black-70'>
                        By inviting your friends, family and others to join your Good Network, you create a greater connection with them and strengthen the causes that bind you.
                    </p>
                </motion.div>
                <div style={{flex: 1, maxWidth: this.props.mobile ? '100%' : '40vw'}} className='col-plain'>
                    <motion.div
                        initial={{opacity: 0, transform: 'scale(1) translateY(12px)'}}
                        whileInView={{opacity: 1, transform: 'scale(1) translateY(-0%)'}}
                        transition={{default: {ease: "linear"}, delay: .2}}
                        onMouseEnter={this.freezeCarousel}
                        onMouseLeave={this.unfreezeCarousel}
                    >
                        {this.switchGraphic()}
                    </motion.div>
                </div>
            </section>
        )
    }
}

export default Section5
